import { isLiveHeader, isLiveLink, type PortalViewerNav } from '../portalNav.js';
import type { PortalLibrarySection } from '../../types/portalLibrary.js';

// CLIENT PORTAL LIBRARY — the document viewer's breadcrumb (Round 5).
//
// ⚠️⚠️ DERIVED FROM THE NAV, NEVER A SECTION→LABEL MAP. The breadcrumb's first
// crumb must say exactly what the left nav says and go exactly where it goes.
// A hand-typed label is how the two drift — Scott called the section "Monthly
// Strategies" while the nav says "Monthly campaigns", and a viewer carrying its
// own copy would have shipped whichever word was typed there.
//
// ⚠️⚠️ ROUND 6: FROM *THE VIEWER'S* NAV. The nav is per-viewer now — industry
// decides the strategy children, content decides Custom reports — so the crumb
// takes the viewer's `PortalViewerNav` as a REQUIRED argument. There is no
// default: a default would be one of the two shapes, and a campaigns viewer's
// crumb would then point at a section their nav does not have.
//
// The library section values ARE the nav node ids (`strategy.*` are live
// CHILDREN under "Strategy decks"; `college` is a live top-level LINK;
// `reports.custom` is the Custom reports row under Reports), so the lookup is by
// id and needs no mapping. breadcrumb.test.ts runs over BOTH nav shapes.

export type LibraryCrumb = { label: string; path: string };

export function librarySectionCrumb(
  section: PortalLibrarySection,
  nav: PortalViewerNav,
): LibraryCrumb | null {
  if (nav.customReports && nav.customReports.id === section) {
    return { label: nav.customReports.label, path: nav.customReports.path };
  }
  for (const item of nav.items) {
    if (isLiveLink(item) && item.id === section) return { label: item.label, path: item.path };
    if (isLiveHeader(item)) {
      const child = item.children.find((c) => c.id === section);
      if (child) return { label: child.label, path: child.path };
    }
  }
  // A section with no node in THIS viewer's nav has nowhere to go back to; the
  // viewer then shows the title alone rather than a crumb pointing at nothing.
  return null;
}
